// export const address = "http://192.168.3.213:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.100:8080/FcarOperateWeb/";
export const address = "http://www.szcitycar.com/";
// export const address = "http://192.168.3.91:8080/";
// export const address = "http://192.168.3.164:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.91:8080/FcarOperateWeb/";
// export const address = "http://192.168.3.53:8098/FcarOperateWeb/";
// export const address = "http://192.168.3.226:8080/FcarOperateWeb/";
// export const address = "http://client.szfcar.com/";



// WEBPACK FOOTER //
// ./src/assets/javascripts/url-public.js